import React from 'react';

import ProductExStockTable from '../components/product-ex-stock/table';

class ProductExStockTablePage extends React.Component{
  render() {
    return (
      <div>
        <ProductExStockTable />
      </div>
    )
  }
}

export default ProductExStockTablePage;


// WEBPACK FOOTER //
// ./src/containers/product-ex-stock-table-page.js